import { takeLatest, put, call } from 'redux-saga/effects';
import { MeetingsAction, MeetingsTypes } from '../types';
import { meetingsError, getListMeetings, updateMeetingNote } from '../actions';
import { getMeetingsListFirebase, updateMeetingNoteFirebase } from '../repository';
import strings from '../../../resources/strings';

export function* requestGetListMeetingsSaga(props: MeetingsAction<{ coachId: string }>): unknown {
    try {
        const meetings = yield call(getMeetingsListFirebase, props.payload.coachId);
        yield put(getListMeetings(meetings));
    } catch (err: unknown) {
        yield put(meetingsError(`${strings.coachPage.errors.fetchMeetings}, error: ${err}`));
    }
}

export function* requestUpdateMeetingNote(props: MeetingsAction<{ meetingId: string; note: string }>): unknown {
    try {
        yield call(updateMeetingNoteFirebase, props.payload.meetingId, props.payload.note);
        yield put(updateMeetingNote(props.payload.meetingId, props.payload.note));
    } catch (err: unknown) {
        yield put(meetingsError(`${strings.coachPage.errors.fetchMeetings}, error: ${err}`));
    }
}

export default [
    takeLatest(MeetingsTypes.REQUEST_UPDATE_MEETING_NOTE, requestUpdateMeetingNote),
    takeLatest(MeetingsTypes.REQUEST_GET_LIST_MEETINGS, requestGetListMeetingsSaga),
];
